import { SearchOutlined } from '@ant-design/icons';
import { ResponseGetTemplates } from '@vindr/services/apis/template.api';
import { ResponseUserInfo } from '@vindr/services/apis/user.api';
import { TEMPLATE_TYPE } from '@vindr/services/constants/report.constant';
import { Empty as AntEmpty, Button, Input, Modal, Tabs } from 'antd';
import { ModalStaticFunctions } from 'antd/es/modal/confirm';
import { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Empty from '../../ui/Empty';

const { Search } = Input;

const TemplateList = ({
  templates,
  onSelect,
}: {
  templates: ResponseGetTemplates['data'];
  onSelect: (val: any) => void;
}) => {
  const [searchKey, setSearchKey] = useState('');
  const filteredTemplates = templates.filter(
    (it) => !searchKey || it?.name.toLowerCase().indexOf(searchKey.toLowerCase()) >= 0
  );
  const { t } = useTranslation('Vindoc');

  return (
    <div>
      <Search
        className="mb-3"
        size="small"
        enterButton={<SearchOutlined className="mb-1 text-base text-black dark:text-white" />}
        placeholder={t('Keyword')}
        onSearch={(value) => setSearchKey(value)}
        style={{ width: '100%' }}
      />
      <div className="max-h-[65vh] overflow-auto">
        {filteredTemplates.map((it, idx) => (
          <Button
            key={it?.id}
            className="w-full border-0 text-left"
            size="small"
            // icon={<ReloadOutlined />}
            onClick={() => onSelect(it)}
          >
            {`${idx + 1}. ${it?.name}`}
          </Button>
        ))}
      </div>
      {!filteredTemplates ||
        (!filteredTemplates.length && <Empty image={AntEmpty.PRESENTED_IMAGE_SIMPLE} />)}
    </div>
  );
};

const SelectTemplate = ({
  visible,
  templates,
  onCancel,
  onSelect,
  userInfo,
  modal,
}: {
  visible: boolean;
  templates: ResponseGetTemplates['data'];
  onCancel: Parameters<typeof Modal>['0']['onCancel'];
  onSelect: (value: any) => void;
  userInfo: ResponseUserInfo['data'];
  modal: Omit<ModalStaticFunctions, 'warn'>;
}) => {
  const { t } = useTranslation('Vindoc');
  const publicTemplates = templates.filter((it) => it.status == TEMPLATE_TYPE.PUBLIC);
  const myTemplates = templates.filter((it) => it?.user_id == userInfo?.id);
  const [activeTab, setActiveTab] = useState('1');

  const handleSelect = useCallback(
    (template) => {
      modal.confirm({
        className: 'delete-modal',
        zIndex: 1200,
        title: t('This template will overwrite your current work?'),
        okText: t('Yes'),
        cancelText: t('No'),
        onOk: () => onSelect(template),
      });
    },
    [modal, onSelect, t]
  );

  const items = useMemo(
    () => [
      {
        key: '1',
        label: t('Default'),
        children: <TemplateList templates={publicTemplates} onSelect={handleSelect} />,
      },
      {
        key: '2',
        label: t('My Templates'),
        children: <TemplateList templates={myTemplates} onSelect={handleSelect} />,
      },
    ],
    [handleSelect, myTemplates, publicTemplates, t]
  );

  return (
    <Modal
      className="vindr-modal add-order max-w-screen"
      title={t('Report Template')}
      open={visible}
      maskClosable={false}
      destroyOnClose
      zIndex={1001}
      onCancel={onCancel}
      footer={null}
    >
      <Tabs
        defaultActiveKey="1"
        activeKey={activeTab}
        items={items}
        onChange={(key) => setActiveTab(key)}
      />
    </Modal>
  );
};

export default SelectTemplate;
